import { useState } from "react";
import "./downloadCredits.scss";
import { trademoTrackingEvents } from "../../core/global/trademo-tracking";
import trackingEventDictionary from "../../core/dictionary/tracking-event";
import { generateTrackingObject } from "../../core/global/global-country-functions";
import axios from "axios";
import { getApiUrl } from "../../utils/baseUrl";
import { toast } from "react-toastify";
import { globalCountryDetailsDictionary } from "../../core/global/global-country-details";
import { captureException } from "@sentry/react";

function DownloadCreditsForm({ analyticsCountryID, pathname, currentUserPlan }) {
  const [feedbackValue, setFeedbackValue] = useState("");

  const handleFeedBackSubmit = (e) => {
    e.preventDefault();
    let countryName = "";
    for (let property in globalCountryDetailsDictionary) {
      let item = property;
      if (pathname.includes(globalCountryDetailsDictionary[item].countryPathName)) {
        countryName = globalCountryDetailsDictionary[item].country_CamelCase;
        break;
      }
    }
    const params = {
      planId: currentUserPlan ?? "",
      countries: countryName,
      key: "feedback",
      feedbackText: feedbackValue ?? "",
    };
    axios
      .get(getApiUrl("notifySales"), { params })
      .then((res) => {
        if (!!res && !!res.data && !!res.data.status && res.data.status.toUpperCase() === "success".toUpperCase()) {
          toast.success(res.data.message);
          setFeedbackValue("");
        } else {
          toast.error(res.data.message ? res.data.message : "Something went wrong. Please try again later !!!");
        }
      })
      .catch((err) => {
        captureException(err);
        toast.error("Something went wrong. Please try again later !!!");
      });
    trademoTrackingEvents(trackingEventDictionary.reportFeedbackSubmit, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
  };

  return (
    <div className="download-credits-container">
      <p className="box-question">Looking for something more specific or wish to provide feedback?</p>
      <p className="box-content">If our pre-built reports don't quite hit the mark, don't hesitate to request a customized report.</p>
      <textarea className="box-textarea" placeholder="Type your requirements here" value={feedbackValue} onChange={(e) => setFeedbackValue(e.target.value)} maxLength={200}></textarea>
      <p className="characters-left">{feedbackValue?.length}/200 characters left</p>
      <button disabled={feedbackValue.length === 0} className="submit-btn" onClick={handleFeedBackSubmit} style={{ cursor: feedbackValue.length === 0 && "no-drop" }}>
        Submit
      </button>
    </div>
  );
}

export default DownloadCreditsForm;
